import { gql } from '@src/lib/gql'

/** Record who is working this thread. A live claim held by someone else stays put. */
export const CLAIM_CRM_THREAD = gql`
  mutation ClaimCrmThread($input: ClaimCrmThreadInput!) {
    claimCrmThread(input: $input) {
      ownerUserId
      ownerDisplayName
      ownedByViewer
      claimExpiresAt
    }
  }
`
